// extracted by mini-css-extract-plugin
export default {"biobar-module-name":"styles_biobar-module-name__Lq87W","biobar-product-name":"styles_biobar-product-name__7epBU"};